export const studentProfileValidation = {
    fullName: {
        validate: (value) => {
            const normalized = String(value || '').trim();
            if (!normalized || normalized.length < 2) {
                return "Full name must be at least 2 characters";
            }
            if (normalized.length > 100) {
                return "Full name cannot exceed 100 characters";
            }
            return null;
        }
    },

    email: {
        validate: (value) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const normalized = String(value || '').trim();
            if (!normalized || !emailRegex.test(normalized)) {
                return "Please enter a valid email address";
            }
            return null;
        }
    },

    contact: {
        validate: (value) => {
            const phoneRegex = /^\d{10}$/;
            const normalized = String(value || '').replace(/\D/g, '');
            if (!normalized || !phoneRegex.test(normalized)) {
                return "Contact must be exactly 10 digits";
            }
            return null;
        }
    },

    gender: {
        validate: (value) => {
            const validGenders = ["male", "female", "other"];
            const normalized = String(value || '').toLowerCase();
            if (!normalized || !validGenders.includes(normalized)) {
                return "Please select a valid gender";
            }
            return null;
        }
    },

    dob: {
        validate: (value) => {
            if (!value) {
                return "Date of birth is required";
            }
            const dobDate = new Date(value);
            if (isNaN(dobDate.getTime())) {
                return "Please enter a valid date";
            }

            const today = new Date();
            let age = today.getFullYear() - dobDate.getFullYear();
            if (today.getMonth() < dobDate.getMonth() ||
                (today.getMonth() === dobDate.getMonth() && today.getDate() < dobDate.getDate())) {
                age--;
            }

            if (age < 15) {
                return "You must be at least 15 years old";
            }
            if (age > 120) {
                return "Please enter a valid date of birth";
            }
            return null;
        }
    },

    city: {
        validate: (value) => {
            const normalized = String(value || '').trim();
            if (!normalized || normalized.length < 2) {
                return "City must be at least 2 characters";
            }
            if (normalized.length > 100) {
                return "City cannot exceed 100 characters";
            }
            return null;
        }
    },

    summary: {
        validate: (value) => {
            if (value && String(value).length > 1000) {
                return "Summary cannot exceed 1000 characters";
            }
            return null;
        }
    },

    experience: {
        validateTitle: (value) => {
            if (!value || value.trim().length < 2) {
                return "Job title is required (min 2 characters)";
            }
            return null;
        },
        validateCompany: (value) => {
            if (!value || value.trim().length < 2) {
                return "Company name is required (min 2 characters)";
            }
            return null;
        },
        validateStartDate: (value) => {
            if (!value || !value.year) {
                return "Start date is required";
            }
            const year = parseInt(value.year);
            if (year < 1900 || year > new Date().getFullYear()) {
                return "Please enter a valid year";
            }
            return null;
        },
        validateEndDate: (value, isCurrent) => {
            if (isCurrent) return null;
            if (!value || !value.year) {
                return "End date is required";
            }
            const year = parseInt(value.year);
            if (year < 1900 || year > new Date().getFullYear()) {
                return "Please enter a valid year";
            }
            return null;
        },
        validateCity: (value) => {
            if (!value || value.trim().length < 2) {
                return "City is required (min 2 characters)";
            }
            return null;
        }
    },

    education: {
        validateInstitution: (value) => {
            if (!value || value.trim().length < 2) {
                return "Institution name is required (min 2 characters)";
            }
            return null;
        },
        validateDegree: (value) => {
            if (!value || value.trim().length < 2) {
                return "Degree is required (min 2 characters)";
            }
            return null;
        },
        validateFieldOfStudy: (value) => {
            if (!value || value.trim().length < 2) {
                return "Field of study is required (min 2 characters)";
            }
            return null;
        },
        validateStartDate: (value) => {
            if (!value || !value.year) {
                return "Start date is required";
            }
            const year = parseInt(value.year);
            if (year < 1900 || year > new Date().getFullYear()) {
                return "Please enter a valid year";
            }
            return null;
        },
        validateEndDate: (value, isCurrent) => {
            if (isCurrent) return null;
            if (!value || !value.year) {
                return "End date is required";
            }
            const year = parseInt(value.year);
            if (year < 1900 || year > new Date().getFullYear()) {
                return "Please enter a valid year";
            }
            return null;
        },
        validateCity: (value) => {
            if (!value || value.trim().length < 2) {
                return "City is required (min 2 characters)";
            }
            return null;
        }
    },

    socialLink: {
        validatePlatform: (value) => {
            if (!value || value.trim().length < 2) {
                return "Platform name is required";
            }
            return null;
        },
        validateUrl: (value) => {
            try {
                new URL(value);
                return null;
            } catch {
                return "Please enter a valid URL";
            }
        }
    }
};
